import React from 'react';
import { usePublicData } from '../../context/PublicDataContext';
import { img, Eyebrow, Display, Reveal, GhostButton } from './components/ui';
import Seo from './components/Seo';

/* Makers = the team, presented as the people and craft behind the work.
 * Uses the existing /website/public/team data (name, designation, image). */
export default function MakersPage() {
  const { team, sections, siteName } = usePublicData();
  const intro = sections.makers || sections.team || {};

  return (
    <>
      <Seo title="Makers" description={`The artisans and craftspeople behind ${siteName}.`} siteName={siteName} />

      <section className="pt-36 pb-16 bg-[#ece0cd]">
        <div className="max-w-6xl mx-auto px-6">
          <Eyebrow>The makers</Eyebrow>
          <Display as="h1" className="text-4xl md:text-[56px] mt-4 max-w-3xl">
            {intro.title || 'The hands behind every joint, finish and frame.'}
          </Display>
          <p className="text-[#4a3d32] max-w-2xl mt-6 text-[15.5px] leading-relaxed">
            {intro.body ||
              'Our furniture is shaped by carpenters, polishers, upholsterers and finishers who have spent years learning their craft. Meet the people who build what leaves our floor.'}
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          {team.length ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
              {team.map((person, i) => (
                <Reveal key={person.id} delay={(i % 3) * 80} className="group">
                  <div className="overflow-hidden bg-[#ece0cd] aspect-[4/5] mb-5">
                    <img src={img(person.image_url)} alt={person.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <h3 className="font-display text-xl">{person.name}</h3>
                  <p className="text-[#b5622f] text-[11px] uppercase tracking-[0.16em] mt-1">{person.designation}</p>
                </Reveal>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 text-[#4a3d32]">
              <p className="font-display text-2xl mb-2 text-[#241811]">Makers coming soon</p>
              <p className="text-sm">Add team members in the admin panel to introduce your makers here.</p>
            </div>
          )}

          <div className="mt-16 text-center">
            <GhostButton to="/craftsmanship">See how it's made</GhostButton>
          </div>
        </div>
      </section>
    </>
  );
}
